import { h, Component } from 'preact';
import Select, { components } from 'react-select';
import axios from 'axios';

const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <img
          className="select-list__dropdown"
          alt="Dropdown arrow"
          src="/public/images/icons/arrow-down.svg"
        />
      </components.DropdownIndicator>
    )
  );
};

class Search extends Component {
  state = {
    locations: [],
    inputValue: '',
    inputFocused: false,
    locationValue: 0,
    menuOpen: false,
    loading: true,
    searching: false,
    searched: false,
    searchResults: [],
    loadedClass: ''
  };

  async componentDidMount() {
    const locations = JSON.parse(
      document.getElementById('location-data').innerHTML
    );
    locations.unshift({
      name: 'All locations',
      id: 0
    });
    const searchQuery = this.getQueryString('q');
    await this.setState(() => ({
      locations: locations.map((location) => ({
        value: location.id,
        label: location.name
      })),
      loading: false,
      inputValue: searchQuery !== null ? decodeURI(searchQuery[1]) : ''
    }));
    if (searchQuery !== null) {
      this.performSearch();
    }
    setTimeout(() => {
      this.setState(() => ({
        loadedClass: 'js-loaded'
      }));
    }, 300);
  }

  getQueryString = (field) => {
    const href = window.location.href;
    const reg = new RegExp(`[?&]${field}=([^&#]*)`, 'i');
    const string = reg.exec(href);
    return string;
  };

  handleInputChange = (e) => {
    this.setState(() => ({
      inputValue: e.target.value
    }));
  };

  performSearch = async (e) => {
    e && e.preventDefault();
    this.setState(() => ({
      searching: true
    }));
    const { data: searchResults } = await axios.get(
      '/umbraco/api/search/dosearch',
      {
        params: {
          role: this.state.inputValue,
          location: this.state.locationValue
        }
      }
    );
    let presearched = this.state.searched;
    this.setState(
      () => ({
        searched: true,
        searching: false,
        searchResults
      }),
      () => {
        if (presearched) {
          document.querySelector('.search__results').scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    );
  };

  render() {
    return (
      <div className={`search ${this.state.loadedClass}`}>
        <form
          className={`search__form ${
            this.state.searched ? 'search__form--searched' : ''
          }`}
          style={{ backgroundImage: `url('${this.props.backgroundImage}')` }}
          onSubmit={this.performSearch}
        >
          <div className="search__wrapper">
            {this.state.loading ? (
              <div className="search__loading-spinner" />
            ) : (
              <div className="search__content">
                <div
                  className={`search__top ${
                    this.state.inputFocused || this.state.inputValue.length > 0
                      ? 'search__top--focused'
                      : ''
                  }`}
                >
                  <p className="search__text">
                    I am looking for{' '}
                    <label className="sr-only" htmlFor="job-search">
                      Enter a job title
                    </label>
                    <input
                      type="text"
                      name="job-search"
                      id="job-search"
                      autocomplete="off"
                      className={`search__input ${
                        this.state.inputFocused ||
                        this.state.inputValue.length > 0
                          ? 'js-focused'
                          : ''
                      }`}
                      placeholder="any job"
                      value={this.state.inputValue}
                      onInput={this.handleInputChange}
                      onFocus={() => {
                        this.setState(() => ({
                          inputFocused: true
                        }));
                      }}
                      onBlur={() => {
                        this.setState(() => ({
                          inputFocused: false
                        }));
                      }}
                    />
                  </p>
                </div>
                <div className="search__bottom">
                  <div className="search__left">
                    <p className="search__text">
                      <span className="search__span">in </span>
                      <label className="sr-only" id="location-select">
                        Select a location
                      </label>
                      <Select
                        aria-labelledby="location-select"
                        options={this.state.locations}
                        styles={selectStyles}
                        className="react-select"
                        classNamePrefix="react-select"
                        placeholder="all locations"
                        components={{ DropdownIndicator }}
                        maxMenuHeight={this.state.searched ? 155 : 300}
                        onMenuOpen={() => {
                          this.setState(() => ({
                            menuOpen: true
                          }));
                        }}
                        onMenuClose={() => {
                          this.setState(() => ({
                            menuOpen: false
                          }));
                        }}
                        onChange={({ value }) => {
                          this.setState(() => ({
                            locationValue: value
                          }));
                        }}
                      />
                    </p>
                    <a
                      href="/locations"
                      className="search__locations-link"
                      style={{
                        visibility: this.state.menuOpen ? 'hidden' : 'visible'
                      }}
                    >
                      Explore locations
                    </a>
                    <br />
                    <a
                      href="https://cnc.engageats.co.uk/LoginV2.aspx"
                      className="search__locations-link"
                      target="_blank"
                      style={{
                        visibility: this.state.menuOpen ? 'hidden' : 'visible'
                      }}
                    >
                      Register for a Vacancy Alert
                    </a>
                  </div>
                  <div className="search__right">
                    <button
                      className={`button button--outline ${this.state
                        .searching && 'js-loading'}`}
                      onClick={this.performSearch}
                      type="submit"
                      style={{
                        visibility:
                          this.state.menuOpen && window.innerWidth < 992
                            ? 'hidden'
                            : 'visible'
                      }}
                    >
                      Search Jobs
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </form>
        <div aria-live="polite">
          {this.state.searched && (
            <div className="search__results">
              <div className="search__results-wrapper">
                <h3 class="search__results-header">
                  We found {this.state.searchResults.length} job
                  {this.state.searchResults.length === 0 ||
                  this.state.searchResults.length > 1
                    ? 's'
                    : ''}
                </h3>
                {this.state.searchResults.length > 0 ? (
                  <ul className="vacancy-list">
                    {this.state.searchResults.map(
                      ({ role, location, salary, closingDate, url }) => (
                        <li className="vacancy-list__item vacancy-list__item--search">
                          <a href={url} className="vacancy-list__link">
                            <h4 className="vacancy-list__title">{role}</h4>
                            <span className="vacancy-list__detail">
                              <i className="icon-location" />
                              {location}
                            </span>
                            <span className="vacancy-list__detail">
                              {salary}
                            </span>
                            <span className="vacancy-list__detail">
                              <i className="icon-calendar" />
                              {closingDate}
                            </span>
                            <button className="button button--blue-outline">
                              View Job
                            </button>
                          </a>
                        </li>
                      )
                    )}
                  </ul>
                ) : (
                  <div className="search__no-results">
                    Your search returned no results.
                    <span className="search__no-results--small">
                      Please try again with a different search term or{' '}
                      <a
                        href="https://cnc.engageats.co.uk/LoginV2.aspx"
                        target="_blank"
                      >
                        register for a vacancy alert
                      </a>
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#5a5a7c',
    padding: '7px 5px 5px 5px',
    borderRadius: 0,
    border: '1px solid rgba(255, 255, 255, 0.2)',
    outline: state.isFocused ? 'none' : 'none',
    boxShadow: 'none !important'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#ddd'
  }),
  option: (provided) => ({
    ...provided,
    opacity: 0.2
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'white'
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none'
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: 'rgba(240, 240, 240, 0.2)',
    color: 'white',
    borderRadius: 0,
    marginTop: 0
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? '#315185' : 'white',
    textAlign: 'left',
    backgroundColor: state.isSelected ? 'white' : 'transparent',
    '&:hover': {
      backgroundColor: state.isSelected ? 'white' : '#b7bfcb',
      color: state.isSelected ? '#232323' : 'white'
    }
  }),
  input: (provided) => ({
    ...provided,
    color: 'white'
  })
};

export default Search;
